import useAccessVoter from "v4/hooks/useAccessVoter";

export default function ImportVoter() {
    const {hasRole} = useAccessVoter();

    const canShowNewImport = () => {
        return hasRole('ROLE_MODULE_IMPORT') || hasRole('ROLE_SYSTEM');
    }

    return {
        canShowNewImport
    };
}
